module.exports = __webpack_public_path__ + "img/lait.266ad2fc.svg";